import { Button } from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Parser } from 'json2csv';
import React from 'react';
import { VEHICLE_TYPES } from '../../functions/api/vehicle/TypeApi';
import { columnTitlesPartners, TABLE } from './columns';

dayjs.extend(utc);

export default function (props) {
  const { currentDataSource } = props;

  const exportCsv = async (fields) => {
    const parser = new Parser({ fields });

    const partnersExport = currentDataSource.map((r) => {
      return {
        ...r,
        vhc_type_name: r.vhc_type_id === VEHICLE_TYPES.CAR ? 'Ô tô' : 'Xe máy',
      };
    });

    const csvData = parser.parse(partnersExport);

    const blob = new Blob(['\ufeff', csvData]);
    const link = document.createElement('a');
    link.download = `exported-partner-${dayjs().format('YYYYMMDD-HHmmss')}.csv`;
    link.href = URL.createObjectURL(blob);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportColumns = columnTitlesPartners
    .filter((t) => t.hideOn !== TABLE.CSV)
    .map((item) => {
      let value = item.dataIndex;

      if (Array.isArray(value)) {
        value = item.dataIndex.join('.');
      }
      return { label: item.title, value };
    });

  return (
    <>
      <Button
        key="submit"
        type="default"
        className="pull-right"
        onClick={() => exportCsv(exportColumns)}
      >
        Download CSV
      </Button>
    </>
  );
}
